/* forged-pdp.js — Forged & Custom PDP behaviour (Plan 2C).
   Quote panel (YMMS cascade, garage prefill, sizing mode, Turnstile, submit),
   vehicle gallery lightbox, scroll reveals, mobile sticky CTA. No add-to-cart here by design. */
(function () {
  'use strict';
  var root = document.querySelector('[data-forged-pdp]');
  if (!root) return;

  var cfg = {
    apiBase: (window.__TFS_FITMENT_CONFIG__ && window.__TFS_FITMENT_CONFIG__.apiUrl) || root.getAttribute('data-api-base') || '',
    sitekey: root.getAttribute('data-turnstile-sitekey') || '',
    handle: root.getAttribute('data-handle') || '',
    phone: root.getAttribute('data-shop-phone') || ''
  };
  cfg.apiBase = String(cfg.apiBase).replace(/\/+$/, '');

  var STANDARD = '(Standard)';

  // ---------------------------------------------------------------------------
  // Fitment API (same public cascade the storefront widget uses)
  // ---------------------------------------------------------------------------
  function apiGet(path, params) {
    var F = window.TFSFitment;
    if (F && F.api && typeof F.api.get === 'function') return F.api.get(path, params || {});
    var qs = Object.keys(params || {}).filter(function (k) { return params[k] != null && params[k] !== ''; })
      .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); }).join('&');
    return fetch(cfg.apiBase + '/api/fitment' + path + (qs ? '?' + qs : ''), { method: 'GET' })
      .then(function (r) { return r.json(); });
  }

  /* The public cascade answers in several shapes depending on the route, and
     ymms-widget.js (extensions/fitment-extension) is the reference reader:
       /years     -> data.data || data.years  || data     (strings, or { year  | value })
       /makes     -> data.data || data.makes  || data     (strings, or { make  | value })
       /models    -> data.data || data.models || data     (strings, or { model | value })
       /submodels -> data.vehicles || data.data || data   (full vehicle ROWS: { id, submodel, chassis, ... })
     Submodels are therefore not a list of labels — they are vehicle rows that have
     to be de-duplicated by `submodel`, with an empty submodel shown as "(Standard)"
     and stripped again on submit, exactly as the widget does. */
  function listFrom(data, keys) {
    if (!data) return [];
    var list = null;
    for (var i = 0; i < keys.length && !list; i++) list = data[keys[i]];
    if (!list) list = data;
    return Array.isArray(list) ? list : [];
  }
  function scalar(item, key) {
    if (item == null) return '';
    if (typeof item === 'object') return String(item[key] != null ? item[key] : (item.value != null ? item.value : ''));
    return String(item);
  }

  // ---------------------------------------------------------------------------
  // Quote panel
  // ---------------------------------------------------------------------------
  var panel = root.querySelector('[data-forged-quote]');
  var form = panel && panel.querySelector('form');
  var selYear, selMake, selModel, selSub, status;
  var vehicleRows = [];

  // Finish preview: options that carry data-swatch (the Brixton menu) show the chosen swatch beside the select.
  var finishSel = form && form.querySelector('[name=finish_preference]');
  var finishChip = form && form.querySelector('[data-finish-chip]');
  if (finishSel && finishChip) {
    finishSel.addEventListener('change', function () {
      var opt = finishSel.options[finishSel.selectedIndex];
      var sw = opt && opt.getAttribute('data-swatch');
      finishChip.hidden = !sw;
      finishChip.style.backgroundImage = sw ? 'url("' + sw + '")' : '';
    });
  }

  function fill(select, items, placeholder, mapFn) {
    if (!select) return;
    select.innerHTML = '';
    var ph = document.createElement('option'); ph.value = ''; ph.textContent = placeholder; select.appendChild(ph);
    (items || []).forEach(function (it) {
      var o = mapFn(it); if (!o || !o.value) return;
      var opt = document.createElement('option'); opt.value = o.value; opt.textContent = o.label;
      if (o.id != null) opt.setAttribute('data-vehicle-id', String(o.id));
      select.appendChild(opt);
    });
    select.disabled = !(items && items.length);
  }
  var plain = function (v) { return v == null || v === '' ? null : { value: String(v), label: String(v) }; };

  /* Collapse vehicle rows to distinct submodels, keeping the first row's id for each.
     /submodels returns one row per chassis variant, so the same trim name comes back
     several times (a "Base" 3 Series is E90/F30/G20; "Turbo S" spans 991 and 992).
     A quote form only needs the trim the shopper recognises, so the duplicates are
     folded away and the first row's vehicle_id rides along as a best-effort hint —
     the fitment specialist confirms the chassis when they reply. */
  function submodelOptions(rows) {
    var seen = {}, out = [];
    (rows || []).forEach(function (r) {
      var label = (r && typeof r === 'object' ? (r.submodel || '') : String(r || '')) || STANDARD;
      if (seen[label]) return;
      seen[label] = true;
      out.push({ value: label, label: label, id: r && r.id != null ? r.id : null });
    });
    return out;
  }
  var identity = function (o) { return o; };

  function loadYears() {
    return apiGet('/years').then(function (d) {
      fill(selYear, listFrom(d, ['data', 'years']).map(function (y) { return scalar(y, 'year'); }), 'Year', plain);
    });
  }
  function loadMakes(y) {
    fill(selMake, [], 'Make', plain); fill(selModel, [], 'Model', plain); fill(selSub, [], 'Trim (optional)', identity);
    vehicleRows = [];
    if (!y) return Promise.resolve();
    return apiGet('/makes', { year: y }).then(function (d) {
      fill(selMake, listFrom(d, ['data', 'makes']).map(function (m) { return scalar(m, 'make'); }), 'Make', plain);
    });
  }
  function loadModels(y, mk) {
    fill(selModel, [], 'Model', plain); fill(selSub, [], 'Trim (optional)', identity);
    vehicleRows = [];
    if (!y || !mk) return Promise.resolve();
    return apiGet('/models', { year: y, make: mk }).then(function (d) {
      fill(selModel, listFrom(d, ['data', 'models']).map(function (m) { return scalar(m, 'model'); }), 'Model', plain);
    });
  }
  function loadSubs(y, mk, md) {
    fill(selSub, [], 'Trim (optional)', identity);
    vehicleRows = [];
    if (!y || !mk || !md) return Promise.resolve();
    return apiGet('/submodels', { year: y, make: mk, model: md }).then(function (d) {
      vehicleRows = listFrom(d, ['vehicles', 'data']);
      fill(selSub, submodelOptions(vehicleRows), 'Trim (optional)', identity);
    });
  }
  /* One place for "does this browser want motion" so both scroll-to-panel paths agree. */
  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function scrollToPanel() {
    if (!panel) return;
    panel.scrollIntoView(prefersReducedMotion() ? { block: 'start' } : { behavior: 'smooth', block: 'start' });
  }

  function setStatus(msg, tone) {
    if (!status) return;
    status.textContent = msg || '';
    status.setAttribute('data-tone', tone || 'error');
  }

  /* The cascade selects are the only required vehicle input; if a fetch fails they stay
     empty and disabled with no explanation, so every hop reports the same fallback. */
  function cascadeFailed() {
    setStatus('Vehicle lists are unavailable right now — type your vehicle in the notes.');
  }

  function prefillFromGarage() {
    var F = window.TFSFitment; var v = F && typeof F.getVehicle === 'function' ? F.getVehicle() : null;
    if (!v || !v.year) return Promise.resolve();
    selYear.value = String(v.year);
    if (!selYear.value) return Promise.resolve();
    return loadMakes(v.year).then(function () {
      selMake.value = v.make || ''; if (!selMake.value) return;
      return loadModels(v.year, v.make).then(function () {
        selModel.value = v.model || ''; if (!selModel.value) return;
        return loadSubs(v.year, v.make, v.model).then(function () {
          if (!v.submodel) return;
          selSub.value = v.submodel;
          if (!selSub.value) selSub.value = STANDARD;
        });
      });
    });
  }

  // Turnstile (explicit render, same pattern as gallery-submit.js)
  var turnstileToken = null, turnstileWidget = null;
  function mountTurnstile() {
    var container = panel.querySelector('.fg-turnstile');
    if (!container || !cfg.sitekey) return;
    function render() {
      if (turnstileWidget != null || !window.turnstile) return;
      turnstileWidget = window.turnstile.render(container, {
        sitekey: cfg.sitekey,
        callback: function (t) { turnstileToken = t; },
        'expired-callback': function () { turnstileToken = null; },
        'error-callback': function () { turnstileToken = null; }
      });
    }
    if (window.turnstile) { render(); return; }
    window._fgTurnstileReady = render;
    if (!document.getElementById('cf-turnstile-script')) {
      var s = document.createElement('script');
      s.id = 'cf-turnstile-script';
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=_fgTurnstileReady';
      s.async = true; s.defer = true;
      document.head.appendChild(s);
    } else {
      // gallery-submit.js already injected the script with its own onload name;
      // poll briefly so both panels can coexist on one page.
      var tries = 0;
      var poll = setInterval(function () {
        if (window.turnstile) { clearInterval(poll); render(); }
        else if (++tries > 40) clearInterval(poll);
      }, 250);
    }
  }

  function utmParams() {
    var out = {}; var sp = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { var v = sp.get(k); if (v) out[k] = v.slice(0, 120); });
    if (document.referrer) out.referrer = document.referrer.slice(0, 200);
    return Object.keys(out).length ? out : null;
  }
  function field(name) { return form && form.elements ? form.elements[name] : null; }
  function value(name) { var el = field(name); return el && el.value != null ? el.value : ''; }
  function num(el) { var v = el && el.value; return v === '' || v == null ? null : Number(v); }
  function markInvalid(names) {
    Array.prototype.forEach.call(form.querySelectorAll('[aria-invalid]'), function (el) { el.removeAttribute('aria-invalid'); });
    var map = {
      name: '[name=name]',
      email: '[name=email]',
      phone: '[name=phone]',
      vehicle: '[name=vehicle_year],[name=vehicle_make],[name=vehicle_model]',
      vehicle_year: '[name=vehicle_year]',
      vehicle_make: '[name=vehicle_make]',
      vehicle_model: '[name=vehicle_model]',
      sizing: '[name=front_diameter],[name=front_width],[name=rear_diameter],[name=rear_width]',
      front_diameter: '[name=front_diameter]',
      front_width: '[name=front_width]',
      rear_diameter: '[name=rear_diameter]',
      rear_width: '[name=rear_width]',
      notes: '[name=notes]'
    };
    var first = null;
    (names || []).forEach(function (n) {
      var sel = map[n]; if (!sel) return;
      Array.prototype.forEach.call(form.querySelectorAll(sel), function (el) {
        el.setAttribute('aria-invalid', 'true');
        if (!first) first = el;
      });
    });
    if (first && typeof first.focus === 'function') first.focus();
  }

  function submit(e) {
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    var mode = (form.querySelector('[name=sizing_mode]:checked') || {}).value || 'expert';
    var subOpt = selSub.options[selSub.selectedIndex];
    var submodel = selSub.value === STANDARD ? '' : selSub.value;
    var body = {
      handle: cfg.handle,
      name: value('name'), email: value('email'), phone: value('phone'),
      vehicle_year: selYear.value, vehicle_make: selMake.value, vehicle_model: selModel.value, vehicle_submodel: submodel,
      vehicle_id: subOpt && subOpt.getAttribute('data-vehicle-id') ? Number(subOpt.getAttribute('data-vehicle-id')) : null,
      sizing_mode: mode,
      front_diameter: mode === 'specified' ? num(field('front_diameter')) : null,
      front_width: mode === 'specified' ? num(field('front_width')) : null,
      rear_diameter: mode === 'specified' ? num(field('rear_diameter')) : null,
      rear_width: mode === 'specified' ? num(field('rear_width')) : null,
      finish_preference: value('finish_preference'),
      notes: value('notes'),
      credit_offer_shown: true,
      utm: utmParams(),
      cf_turnstile_response: turnstileToken
    };
    if (!body.name || !body.email || !body.vehicle_year || !body.vehicle_make || !body.vehicle_model) {
      markInvalid(['name', 'email', 'vehicle']); setStatus('Please add your name, email and vehicle.'); return;
    }
    if (mode === 'specified' && (!body.front_diameter || !body.front_width)) { markInvalid(['sizing']); setStatus('Enter at least a front diameter and width, or let our expert choose.'); return; }
    if (cfg.sitekey && !turnstileToken) { setStatus('Please complete the verification box.'); return; }
    btn.disabled = true; setStatus('Sending your request…', 'ok');
    fetch(cfg.apiBase + '/api/forged/quote-requests', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) { return { status: r.status, json: j }; });
    })
      .then(function (res) {
        if (res.status === 201 && res.json && res.json.success) {
          panel.classList.add('is-done');
          var vLabel = [body.vehicle_year, body.vehicle_make, body.vehicle_model, body.vehicle_submodel].filter(Boolean).join(' ');
          var out = panel.querySelector('[data-quote-vehicle]'); if (out) out.textContent = vLabel;
          var h = panel.querySelector('.fg-quote__success h3');
          if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
          if (window.TFSFitment && typeof window.TFSFitment.emit === 'function') window.TFSFitment.emit('forged-quote-requested', { handle: cfg.handle });
          return;
        }
        btn.disabled = false;
        if (window.turnstile && turnstileWidget != null) { window.turnstile.reset(turnstileWidget); turnstileToken = null; }
        if (res.status === 400) { markInvalid(res.json && res.json.fields); setStatus((res.json && res.json.error) || 'Please check the form.'); return; }
        if (res.status === 429) { setStatus('Too many requests from this connection. Please try again in a few minutes' + (cfg.phone ? ' or call ' + cfg.phone : '') + '.'); return; }
        setStatus('We could not send your request. Please try again' + (cfg.phone ? ' or call ' + cfg.phone : '') + '.');
      })
      .catch(function () {
        btn.disabled = false;
        if (window.turnstile && turnstileWidget != null) { window.turnstile.reset(turnstileWidget); turnstileToken = null; }
        setStatus('Network error. Please try again' + (cfg.phone ? ' or call ' + cfg.phone : '') + '.');
      });
  }

  if (form) {
    selYear = field('vehicle_year'); selMake = field('vehicle_make'); selModel = field('vehicle_model'); selSub = field('vehicle_submodel');
    status = panel.querySelector('.fg-quote__status');
    var sizingFields = form.querySelector('.fg-sizing__fields');
    Array.prototype.forEach.call(form.querySelectorAll('[name=sizing_mode]'), function (r) {
      r.addEventListener('change', function () {
        if (sizingFields) sizingFields.hidden = form.querySelector('[name=sizing_mode]:checked').value !== 'specified';
      });
    });
    selYear.addEventListener('change', function () { loadMakes(selYear.value).catch(cascadeFailed); });
    selMake.addEventListener('change', function () { loadModels(selYear.value, selMake.value).catch(cascadeFailed); });
    selModel.addEventListener('change', function () { loadSubs(selYear.value, selMake.value, selModel.value).catch(cascadeFailed); });
    form.addEventListener('submit', submit);
    loadYears().then(prefillFromGarage).catch(cascadeFailed);
    mountTurnstile();
    if (window.location.hash === '#quote') { setTimeout(scrollToPanel, 50); }
  }

  // ---------------------------------------------------------------------------
  // Gallery lightbox
  // ---------------------------------------------------------------------------
  var tiles = Array.prototype.slice.call(root.querySelectorAll('.fg-gallery__tile'));
  var lb = root.querySelector('.fg-lightbox');
  if (tiles.length && lb) {
    var lbImg = lb.querySelector('.fg-lightbox__img');
    var lbCap = lb.querySelector('.fg-lightbox__cap');
    var lbClose = lb.querySelector('.fg-lightbox__close');
    var lbPrev = lb.querySelector('.fg-lightbox__prev');
    var lbNext = lb.querySelector('.fg-lightbox__next');
    var idx = 0, lastFocus = null;
    var single = tiles.length < 2;
    if (single) { if (lbPrev) lbPrev.hidden = true; if (lbNext) lbNext.hidden = true; }
    var show = function (i) {
      idx = (i + tiles.length) % tiles.length;
      var t = tiles[idx];
      lbImg.src = t.getAttribute('data-full'); lbImg.alt = t.getAttribute('data-alt') || '';
      lbCap.textContent = t.getAttribute('data-cap') || '';
    };
    var open = function (i) {
      lastFocus = document.activeElement; show(i); lb.hidden = false;
      document.body.style.overflow = 'hidden';
      if (lbClose) lbClose.focus();
    };
    var close = function () {
      lb.hidden = true; lbImg.removeAttribute('src'); document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    tiles.forEach(function (t, i) { t.addEventListener('click', function () { open(i); }); });
    if (lbClose) lbClose.addEventListener('click', close);
    if (lbPrev) lbPrev.addEventListener('click', function () { show(idx - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (!single && e.key === 'ArrowLeft') show(idx - 1);
      else if (!single && e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'Tab') {
        // Keep focus inside the dialog.
        var focusables = Array.prototype.filter.call(lb.querySelectorAll('button'), function (b) { return !b.hidden; });
        if (!focusables.length) return;
        var firstEl = focusables[0], lastEl = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
        else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Reveals + sticky CTA
  // ---------------------------------------------------------------------------
  var reveals = root.querySelectorAll('.fg-reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(reveals, function (el) { io.observe(el); });
  } else { Array.prototype.forEach.call(reveals, function (el) { el.classList.add('is-in'); }); }

  var sticky = root.querySelector('.fg-sticky');
  var hero = root.querySelector('.fg-hero');
  if (sticky && hero && panel && 'IntersectionObserver' in window) {
    var heroOut = false, panelIn = false;
    var upd = function () {
      var on = heroOut && !panelIn;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    new IntersectionObserver(function (en) { heroOut = !en[0].isIntersecting; upd(); }, { threshold: 0.05 }).observe(hero);
    new IntersectionObserver(function (en) { panelIn = en[0].isIntersecting; upd(); }, { threshold: 0.2 }).observe(panel);
    var stickyCta = sticky.querySelector('a');
    if (stickyCta) stickyCta.addEventListener('click', function (e) { e.preventDefault(); scrollToPanel(); });
  }
})();
